// Pausa temporária, acompanhando as rotinas desativadas na API.
export const DRIVER_ALERTS_ENABLED = false;
export const DASHBOARD_DISTANCE_FUEL_ENABLED = false;

type RuntimeConfig = {
    GTR_GEOCODER_KEY?: string;
    GTR_MAPS_KEY?: string;
    GTR_MAPS_ID?: string;
    GTR_MAPS_DISABLED_ID?: string;
};

declare global {
    interface Window {
        __RUNTIME_CONFIG__?: RuntimeConfig;
    }
}

const runtimeConfig = window.__RUNTIME_CONFIG__ ?? {};

export const GTR_API_BASE_URL = process.env.REACT_APP_GTR_API_BASE_URL
    || (process.env.NODE_ENV === "development"
        ? "http://localhost:8083"
        : "https://gtr.sistemagtf.com.br/api");
export const GTR_GEOCODER_KEY = runtimeConfig.GTR_GEOCODER_KEY
    || process.env.REACT_APP_GTR_GEOCODER_KEY
    || "";
export const GTR_MAPS_KEY = runtimeConfig.GTR_MAPS_KEY
    || process.env.REACT_APP_GTR_MAPS_KEY
    || "";
export const GTR_MAPS_ID = runtimeConfig.GTR_MAPS_ID
    || process.env.REACT_APP_GTR_MAPS_ID
    || "";
export const GTR_MAPS_DISABLED_ID = runtimeConfig.GTR_MAPS_DISABLED_ID
    || process.env.REACT_APP_GTR_MAPS_DISABLED_ID
    || "";
